import { Component, Inject, OnInit, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Config } from 'src/app/app-constant';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { MobileResponsiveService } from 'src/app/services/mobile-view/mobile-responsive.service';
import { calculateFiscalYear, formatYearRanges } from 'src/app/shared/commen-function-file';
import { ColDef, ExcelExportParams } from 'ag-grid-community';
import { GridOptions } from 'ag-grid-community';

@Component({
  selector: 'app-asset-dashboard-details',
  templateUrl: './asset-dashboard-details.component.html',
  styleUrls: ['./asset-dashboard-details.component.scss'],
})
export class AssetDashboardDetailsComponent implements OnInit, AfterViewInit {
  loggedInUserId: any;
  moduleName: any;
  allDataForDispay: any = [];
  newAssetListingData: any = [];
  repairedAsset: any = [];
  returnAsset: any = [];
  EmployeereturnAsset: any = [];
  notRecivedAsset: any = []
  isToggleOn: boolean = true;
  gridApi: any
  searchTaskString: string = '';
  type: any = "Recived Asset";
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private httpService: HttpService, private config: Config, private encryptionService: EncryptionService, public mobileResponsiveService: MobileResponsiveService, private cdr: ChangeDetectorRef, private dialogRef: MatDialogRef<AssetDashboardDetailsComponent>) {
    
    this.moduleName = data.moduleName;
    this.allDataForDispay = data.allApiData;
    this.repairedAsset = data.repairedsset;
    this.loggedInUserId = data.loggdingUserId;
    
    // let findLogdinUserAsaAuthority =  sessionStorage.getItem('findLogdinUserAsaAuthority');
    // const newValue = (findLogdinUserAsaAuthority == 'true') ? data.newAllAssetListingData.filter((empData: any) => empData.userId == this.loggedInUserId) : data.newAllAssetListingData;
    this.newAssetListingData = data.newAllAssetListingData
 
    const findLogdinUserAsaAuthority = sessionStorage.getItem('findLogdinUserAsaAuthority');

if (findLogdinUserAsaAuthority === 'true' && data.allAuthorityAssets && data.loggedinUserName) {
  const authorityAssets = data.allAuthorityAssets.filter(
    (asset: any) => asset.authorityName === data.loggedinUserName
  );

  const authorityBands = [...new Set(authorityAssets.flatMap((a: any) => a.bands))];
  this.newAssetListingData = this.newAssetListingData
    .filter((emp: any) =>
      authorityBands.includes(emp.band) &&
      String(emp.userId) !== String(data.loggdingUserId)  // Exclude authority themself
    )
    .map((emp: any) => {
      const matchingAssets = authorityAssets.filter((asset: any) =>
        asset.bands.includes(emp.band)
      );
      const allowedAssetNames = matchingAssets.map((a: { assetName: any; }) => a.assetName);

      return {
        ...emp,
        unassignedAssets: emp.unassignedAssets?.filter((assetName: string) =>
          allowedAssetNames.includes(assetName)
        ) || []
      };
    });

  console.log("Filtered Authority Asset Data ", this.newAssetListingData);
}


  }

  ngAfterViewInit(): void {
    // If this component is opened inside a MatDialog, wait until the dialog is fully opened
    // then ensure the grid lays out correctly. This prevents the grid from rendering invisible
    // because the host container was not yet measured.
    try {
      if (this.dialogRef && typeof this.dialogRef.afterOpened === 'function') {
        this.dialogRef.afterOpened().subscribe(() => {
          // run layout on next animation frame to minimize perceived delay
          requestAnimationFrame(() => this.ensureGridLayout());
        });
      }
    } catch (e) {
      // ignore if MatDialogRef isn't available
    }
  }

  private ensureGridLayout() {
    if (!this.gridApi) return;
    try {
      if (typeof this.gridApi.sizeColumnsToFit === 'function') this.gridApi.sizeColumnsToFit();
      if (typeof this.gridApi.redrawRows === 'function') this.gridApi.redrawRows();
      if (typeof this.gridApi.refreshCells === 'function') this.gridApi.refreshCells();
      if (typeof this.gridApi.resetColumnState === 'function') this.gridApi.resetColumnState();
      // some environments require a resize event for ag-grid to recompute sizes
      try { window.dispatchEvent(new Event('resize')); } catch (e) { /* noop */ }
      try { this.cdr.detectChanges(); } catch (e) { /* noop */ }
    } catch (e) {
      console.warn('ensureGridLayout failed', e);
    }
  }


  ngOnInit() {
    this.returnData()
  }
  

  exportDashboardListExcel() {


    // Define the fields to be downloaded
    const exportFields1 = [
      'assetName',
        'band',
      'employeeName',
    
      

    ];
    const exportFields2 = [
      'employeeName',
      'unassignedAssets',
      'dateOfJoining',

    ];
    const exportFields3 = [
      'assetName',
      'statusChangeCount',
    ];
    const exportFields4 = [
      'assetName',
      'employeeName',
    ];
    // Extract headers for the selected fields
    const header1 = ['Asset', 'Band', 'Employee Name'];
    const header2 = ['Employee Name', 'Unassigned Assets', 'Date of Joining'];
    const header3 = ['Asset', ' Number Off Time Repaired Asset'];
    const header4 = ['Asset', ' Employee Name'];
    // Extract rows with only the selected fields
    const tab1 = this.allDataForDispay.map((record: any) =>
      exportFields1.map(field => `"${record[field] || ''}"`).join(',')
    );

    
    // const tab2 = this.newAssetListingData.map((record: any) =>
    //   exportFields2.map(field => `"${record[field] || ''}"`).join(',')
    // );
    
    const tab2 = this.newAssetListingData.map((record: any) =>
      exportFields2.map(field => {
        if (field === 'dateOfJoining' && record[field]) {
          const date = new Date(record[field]);
          const formattedDate = `${String(date.getDate()).padStart(2, '0')}-${String(date.getMonth() + 1).padStart(2, '0')}-${date.getFullYear()}`;
          return `"\t${formattedDate}"`;  // <-- Add tab inside quotes to preserve format
        }
        return `"${record[field] || ''}"`;
      }).join(',')
    );
    
    const tab3 = this.repairedAsset.map((record: any) =>
      exportFields3.map(field => `"${record[field] || ''}"`).join(',')
    );
    const tab4 = this.returnAsset.map((record: any) =>
      exportFields4.map(field => `"${record[field] || ''}"`).join(',')
    );
    let rows = this.moduleName == 1 ? tab1 : this.moduleName == 2 ? tab2 : this.moduleName == 3 ? tab3 : tab4;
    let header = this.moduleName == 1 ? header1 : this.moduleName == 2 ? header2 : this.moduleName == 3 ? header3 : header4;
    // Create the CSV content
    const csvContent = [header, ...rows].join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const data = this.type == 'Recived Asset' ? 'Recived Asset' : 'Not Recived Asset';
    const moduleName = this.moduleName == 1 ? 'No Of Asset' : this.moduleName == 2 ? 'No of New Asset' : this.moduleName == 3 ? 'No of Time Repaired Asset' : data;
    // Trigger the download
    const a = document.createElement('a');
    a.href = url;
    const date = new Date();
    
    
    const formattedDate = `${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth() + 1).padStart(2, '0')}/${date.getFullYear()}`;
    console.log("date is......",formattedDate);
    a.download = `${moduleName}-${formattedDate}`
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
  returnAssetFromEmp: any = []
  returnData() {
    this.returnAssetFromEmp = this.allDataForDispay.filter((elm: any) => elm.authorityDepartmentComment == 'RECEIVED_AFTER_EXIT');
    this.notRecivedAsset = this.allDataForDispay.filter((elm: any) => elm.authorityDepartmentComment == 'NOT_RECEIVED_AFTER_EXIT');
    this.returnAsset = this.type == 'Recived Asset' ? this.returnAssetFromEmp : this.notRecivedAsset;

  }
  onChangeSwitch(event: any) {
    this.isToggleOn = event?.checked;


    if (event?.checked == true) {
      this.type = 'Recived Asset';
      if ((this.moduleName == 4) && event?.checked == true) {
        this.type = 'Recived Asset';
      }
      this.returnData();
    } else if (event?.checked == false) {


      this.type = 'Not Recived Asset';
      if ((this.moduleName == 4) && event?.checked == false) {
        this.type = 'Not Recived Asset';
      }
      this.returnData();

    }
  }
  defaultColDef: ColDef = {
    flex: 1,
    sortable: true,
    filter: true,
    resizable: true,
  };
  gridOptions: GridOptions = {
    suppressMovableColumns: false,
    // do NOT add suppressHeaderClickSorting here, your version doesn’t support it
  };

  columnDefs1: ColDef[] = [
    { headerName: 'Asset', field: 'assetName' },
    { headerName: 'Band', field: 'band' },
    { headerName: 'Employee Name', field: 'employeeName' },
  ];

  columnDefs2: ColDef[] = [
    { headerName: 'Employee Name', field: 'employeeName' },
    { headerName: 'Unassigned Asset', field: 'unassignedAssets' },
    { headerName: 'Date Of Joining', field: 'dateOfJoining', valueFormatter: this.dateRenderer },
  ];

  columnDefs3: ColDef[] = [
    { headerName: 'Asset', field: 'assetName' },
    { headerName: 'Number Of Time Repaired Asset', field: 'statusChangeCount' },
  ];

  columnDefs4: ColDef[] = [
    { headerName: 'Asset', field: 'assetName' },
    { headerName: 'Employee Name', field: 'employeeName' },
  ];
  dateRenderer(params: any) {
      if (!params.value) return '';
      const date = new Date(params.value);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    }
    paginationPageSizeSelector = [5, 10, 20,50,100,200,500,1000];
  pagination = true;
  paginationPageSize = 10;
     isClicked = false;
    resetGrid() {
      this.isClicked = false; // Trigger animation
    
      if (this.gridApi) {
        // ✅ Reset filters & sorting
        this.gridApi.setFilterModel(null);
        // Reset sort model (if set)
        if (typeof this.gridApi.setSortModel === 'function') {
          this.gridApi.setSortModel(null);
        }
        // Deselect all rows
        if (typeof this.gridApi.deselectAll === 'function') {
          this.gridApi.deselectAll();
        }

        // ✅ Reset quick filter (search box)
        this.searchTaskString = '';
        // Use setQuickFilter which is the proper API to clear quick filter text
        if (typeof this.gridApi.setQuickFilter === 'function') {
          this.gridApi.setQuickFilter('');
        }
    
        // ✅ Reset pagination
        this.paginationPageSize = 10;
        this.gridApi.setGridOption('paginationPageSize', this.paginationPageSize);
        this.gridApi.paginationGoToFirstPage();
    
        // ✅ Force refresh so UI input also clears
        this.gridApi.refreshCells();
        this.gridApi.resetColumnState();         // ✅ Reset columns
      }
    }
    onBtExport(strMsg:any) {
        const params: ExcelExportParams = {
          fileName: strMsg+'_' + new Date().toISOString().slice(0, 10) + '.xlsx',
          sheetName: strMsg,
          exportAsExcelTable: {
            showRowStripes: true,
            name: strMsg
          },
          processCellCallback: (cell) => {
            const header = cell.column.getColDef().headerName;
            const value = cell.value;
     
            // 1. Date Formatting (for specific headers)
            const dateColumns = ['createdAt', 'dateOfJoining']; // <- field names ya headerName use karo
     
            if (dateColumns.includes(cell.column.getColId()) && cell.value) {
              const date = new Date(cell.value);
              if (!isNaN(date.getTime())) {
                return (
                  ('0' + date.getDate()).slice(-2) +
                  '-' +
                  ('0' + (date.getMonth() + 1)).slice(-2) +
                  '-' +
                  date.getFullYear()
                );
              }
            }
     
            // 2. Status Formatting (make it human readable)
            if (header === 'Employee Status' || header === 'Authority Department Comment' && value) {
              return value
                .toString()
                .toLowerCase()
                .replace(/_/g, ' ') // replace underscores with space
                .replace(/\b\w/g, (char:any) => char.toUpperCase()); // capitalize each word
            }
     
            return value;
          }
        };
     
        // Excel export is an enterprise feature in some setups. Fall back to CSV if Excel export method isn't available.
        if (this.gridApi) {
          if (typeof this.gridApi.exportDataAsExcel === 'function') {
            this.gridApi.exportDataAsExcel(params);
          } else if (typeof this.gridApi.exportDataAsCsv === 'function') {
            // Convert filename extension for CSV
            const csvFileName = (params.fileName || strMsg) .replace(/\.xlsx$/i, '.csv');
            this.gridApi.exportDataAsCsv({ fileName: csvFileName });
          } else {
            console.warn('Export not available: grid API does not support exportDataAsExcel or exportDataAsCsv');
          }
        } else {
          console.warn('Export failed: gridApi is not initialized yet.');
        }
      }
   
      onGridReady(params: any) {
      this.gridApi = params.api;
      // Try to size and refresh after the grid is initialized. In dialogs/ionic containers
      // the grid may be initialized before the host container has a stable size, so
      // run sizing/refresh in a short timeout to ensure it lays out correctly.
      try {
        // immediate sizing
        if (typeof this.gridApi.sizeColumnsToFit === 'function') {
          this.gridApi.sizeColumnsToFit();
        }

        // schedule a layout on the next animation frame (faster than setTimeout)
        requestAnimationFrame(() => {
          if (this.gridApi) {
            if (typeof this.gridApi.sizeColumnsToFit === 'function') this.gridApi.sizeColumnsToFit();
            if (typeof this.gridApi.redrawRows === 'function') this.gridApi.redrawRows();
            if (typeof this.gridApi.refreshCells === 'function') this.gridApi.refreshCells();
          }
          try { this.cdr.detectChanges(); } catch (e) { /* noop */ }
        });
      } catch (e) {
        console.warn('ag-Grid sizing failed onGridReady', e);
      }
}

}
